import testFnc from "./components/test";
testFnc();


import linearBorder from "./components/linearBorder";
linearBorder();

import modals from "./components/modals";
modals();

import tabs from "./components/tabs";
tabs();

import selections from "./components/selections";
selections();

import abonimentPrices from "./components/abonimentPrices";
abonimentPrices();

import mask from "./components/mask";
mask();

import forms from "./components/forms";
forms();
